export const MB_TO_BYTE_MULTIPLIER = 1024 * 1024;

export const THUMBNAILS_MODE_PARAM = 'thumbnails_mode';

export const CLOUDINARY_SUPPORTED_IMAGE_EXTENSIONS = [
    'jpeg',
    'jpg',
    'png',
    'gif',
    'webp',
    'bmp',
    'tiff',
    'tif',
    'ico',
    'pdf',
    'svg',
    'psd',
    'ai',
    'eps',
    'heif',
    'heic'
];

const EXTENSION_TO_MIME_MAP: Record<string, string> = {
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
    bmp: 'image/bmp',
    tiff: 'image/tiff',
    tif: 'image/tiff',
    ico: 'image/x-icon',
    svg: 'image/svg+xml',
    psd: 'image/vnd.adobe.photoshop',
    heif: 'image/heif',
    heic: 'image/heic',
    pdf: 'application/pdf',
    ai: 'application/postscript',
    eps: 'application/postscript'
};

export const IMAGE_ONLY_EXTENSIONS =
    CLOUDINARY_SUPPORTED_IMAGE_EXTENSIONS.filter(ext =>
        EXTENSION_TO_MIME_MAP[ext]?.startsWith('image/')
    );

export const AcceptedFileFormats = {
    AllImages: ['image/*'],
    CloudinarySupported: CLOUDINARY_SUPPORTED_IMAGE_EXTENSIONS,
    ImagesOnly: IMAGE_ONLY_EXTENSIONS
};
